export default "/_next/static/images/1437eeb2e28dbb2919069c1f94dec4c6.jpg";